import {Injectable} from '@angular/core';

import moment from 'moment';

@Injectable()
export class ShipmentListSettingsService {
  allShipmentsDateFromFilterValue = 'taskr_allShipmentsDateFromFilterValue';
  allShipmentsDateToFilterValue = 'taskr_allShipmentsDateToFilterValue';

  setAllShipmentsDateFromFilterValue(value: Date) {
    let stringValue = null;

    if (value != null) {
      stringValue = moment(value).format('YYYY-MM-DD');
    }

    localStorage.setItem(this.allShipmentsDateFromFilterValue, stringValue);
  }

  getAllShipmentsDateFromFilterValue(): Date {
    let result: Date;
    let value = localStorage.getItem(this.allShipmentsDateFromFilterValue);

    if (value == null) {
      result = moment().subtract(2, 'months').toDate();
    } else {
      result = moment.utc(value, 'YYYY-MM-DD').toDate();
    }

    if (result != null && result.toString() != 'Invalid Date') {
      return result;
    }

    return null;
  }

  setAllShipmentsDateToFilterValue(value: Date) {
    let stringValue = null;

    if (value != null) {
      stringValue = moment(value).format('YYYY-MM-DD');
    }

    localStorage.setItem(this.allShipmentsDateToFilterValue, stringValue);
  }

  getAllShipmentsDateToFilterValue(): Date {
    let value = localStorage.getItem(this.allShipmentsDateToFilterValue);

    let date = value != null ? moment.utc(value, 'YYYY-MM-DD').toDate() : null;

    if (date != null && date.toString() != 'Invalid Date') {
      return date;
    }

    return null;
  }
}
